import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';

const mockModels = [
  {
    name: 'typhoon-ocr',
    price: '$0.03',
    description: 'Offers specialized OCR model optimized for Thai text recognition',
  },
];

const AiServiceOCRPricing = () => {
  return (
    <div className="container py-10">
      <h1 className="mb-2 text-2xl font-bold">Pricing</h1>
      <p className="mb-8 text-muted-foreground">
        Pricing is per request processed.
      </p>
      <div className="space-y-6">
        <div>
          {/* <h2 className="mb-4 text-lg font-semibold">Model Pricing</h2> */}
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Model</TableHead>
                <TableHead>Price per request</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {mockModels.map((model) => (
                <TableRow key={model.name}>
                  <TableCell>
                    <div className="font-mono text-lg">{model.name}</div>
                    {/* <div className="text-xs text-muted-foreground mt-1">{model.description}</div> */}
                  </TableCell>
                  <TableCell className="font-semibold text-base">{model.price}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default AiServiceOCRPricing;
